import Proptypes from 'prop-types'
import { StyledSketchFabContainer } from './styles'
import { useOnlineStatus } from '../../hooks/useOnlineStatus'
import PwaOfflinePlaceholder from 'components/PwaOfflinePlaceholder'

const SketchFab = ({ part, className }) => {
  const online = useOnlineStatus()

  if (!online) {
    return <PwaOfflinePlaceholder />
  }

  return (
    <StyledSketchFabContainer className={className}>
      {part.title && (
        <h2
          style={{
            margin: '0 0 10px 45px',
            fontSize: '24px',
            fontWeight: '600',
            color: '#333',
            justifySelf: 'center',
          }}
        >
          {part.title}
        </h2>
      )}
      <iframe
        title="A 3D model"
        width="100%"
        height={part.height || '600px'}
        src={part.src}
        frameBorder="0"
        allow="autoplay; fullscreen; vr; accelerometer; xr-spatial-tracking; gyroscope"
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
      />
      {part.legend && part.legend.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <legend
            style={{
              fontSize: part.legendSize ? (part.legendSize === 'small' ? '13px' : '16px') : '13px',
            }}
          >
            {part.legend}
          </legend>
        </div>
      )}
    </StyledSketchFabContainer>
  )
}

SketchFab.propTypes = {
  part: Proptypes.object,
  className: Proptypes.string,
}

export default SketchFab
